module.exports = __webpack_public_path__ + "static/assets/9ad12a9de73f49fb645902987027eb2b.mp3";